export const styles = {
  cardsContainer: {
    display: 'grid',
    gap: 5,
    gridTemplateColumns: 'repeat(2, minmax(80px, 1fr))',
  },
};
